// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y5gkNw3NxX0GMQKhVtYM{align-items:center;max-width:100%;display:flex}.vIqvNnzYtws5VB2n1ME8 .dDR4kNy5QNwx3pozRaMX{margin-left:8px}.dDR4kNy5QNwx3pozRaMX{color:var(--content-primary-primary);max-width:150px;margin-right:6px}.uYw78nCqdQYXP0gTpdUz{color:var(--content-primary-primary)}.mMeQiBLGdQH4QQI6MOAQ{height:auto;min-height:32px}.Vfz79qypKgUqh5P2GThB{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.ORpXhLudx8sZJVjQyzh0{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Y5gkNw3NxX0GMQKhVtYM`,
	"wrap--checkbox": `vIqvNnzYtws5VB2n1ME8`,
	"wrapCheckbox": `vIqvNnzYtws5VB2n1ME8`,
	"title": `dDR4kNy5QNwx3pozRaMX`,
	"label": `uYw78nCqdQYXP0gTpdUz`,
	"dropdown": `mMeQiBLGdQH4QQI6MOAQ`,
	"highlighter": `Vfz79qypKgUqh5P2GThB`,
	"highlighter--label": `ORpXhLudx8sZJVjQyzh0`,
	"highlighterLabel": `ORpXhLudx8sZJVjQyzh0`
};
export default ___CSS_LOADER_EXPORT___;
